<template>
  <div>
    <el-card>
      <el-table
        :data="
          tableData.filter(
            (data) =>
              !filter ||
              data.description.toLowerCase().includes(filter.toLowerCase()) ||
              data.code.toLowerCase().includes(filter.toLowerCase())
          )
        "
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="code"
          :label="$t('codigo')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="description"
          :label="$t('descricao')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="type"
          :label="$t('tipo')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="active"
          :label="$t('ativa')"
        ></el-table-column>
        <el-table-column width="180">
          <template slot-scope="scope">
            <el-button
              type="info"
              icon="el-icon-search"
              @click="editar(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.name)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="`Ocorrência ${occurrence.code} - ${occurrence.description}`"
      :visible.sync="dialogFormVisible"
      width="85%"
      @close="dialogFormVisible = false"
    >
      <OccurrenceAdd
        :occurrence="occurrence"
        :attachments="hasAttachments"
        :collecteds="collecteds"
      />
    </el-dialog>
  </div>
</template>
<script>
import OccurrenceAdd from "./OccurrenceAdd.vue";
import { OccurrenceService } from "@/services/umov/occurrence.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "Occurrence",
  props: ["status", "collecteds"],
  components: {
    OccurrenceAdd,
  },
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      OccurrenceService.list()
        .then(({ records }) => {
          records.forEach((item) => {
            item.code = item.code;
            item.active = item.active ? "Ativa" : "Inativa";

            switch (item.type) {
              case "1":
                item.type = "Informativa";
                break;

              case "2":
                item.type = "Gera Pendência";
                break;

              case "3":
                item.type = "Finaliza Processo";
                break;

              default:
                item.type = "";
                break;
            }
          });
          vm.tableData = records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    add() {
      this.$router.replace({ name: "occurrence.add" });
    },

    editar: function (id) {
      const vm = this;
      OccurrenceService.get(id)
        .then((item) => {
          item.code = item.code;
          switch (item.type) {
            case "1":
              item.type = "Informativa";
              break;

            case "2":
              item.type = "Gera Pendência";
              break;

            case "3":
              item.type = "Finaliza Processo";
              break;

            default:
              item.type = "";
              break;
          }

          vm.occurrence = item;

          // ALTERAR PARA VER DESCRIÇÃO OU FOTO
          item.attachments.length > 0
            ? (vm.hasAttachments = true)
            : (vm.hasAttachments = false);
        })
        .finally(() => (vm.dialogFormVisible = true));
    },

    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-ocorrencia", { role: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        if (vm.status.toLowerCase() != "finalizado") {
          loading.close();
          this.$message({
            type: "error",
            message: "Atendimento não finalizado",
          });

          return;
        }

        OccurrenceService.delete(id)
          .then((response) => {
            setTimeout(() => {
              const index = vm.tableData.findIndex((dt) => dt.id == id);
              vm.tableData.splice(index, 1);
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("ocorrencia-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },

  data() {
    return {
      filter: "",
      tableData: [],
      occurrence: "",
      hasAttachments: false,
      dialogFormVisible: false,
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>
